import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const CleaningSchema: RegistryItem = {
	[AgreementTypeEnum.Cleaning]: {
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
